export default "__VITE_ASSET__Jal6Yr25__"